export default "__VITE_ASSET__Bxv3zTLC__"